<template>
  <div class="middle cadfm-flexitem-stretched">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button @click="back" icon="back" bold :text="lang.button_Back" :tooltip="lang.button_Back"
            :disabled="backButtonStatus" />
          <action-button v-show="buttonStatus == 0" @click="importing" icon="import" bold :text="lang.button_Import"
            :tooltip="lang.button_Import" :disabled="importButtonStatus" />
          <action-button v-show="buttonStatus == 1" @click="getProperties" icon="import" bold
            :text="lang.button_ImportByPartType" :tooltip="lang.button_ImportByPartType"
            :disabled="importByPartButtonStatus" />
          <action-button v-show="buttonStatus == 2" @click="importingMix" icon="import" bold
            :text="lang.button_ImportByPartType" :tooltip="lang.button_ImportMix" :disabled="importMixButtonStatus" />



        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold
            :text="lang.button_Left" :tooltip="lang.button_Left" :disabled="toggleButtonStatus" />
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold
            :text="lang.button_Right" :tooltip="lang.button_Right" :disabled="toggleButtonStatus" />

        </b-navbar-nav>
      </action-bar>
      <action-content>
        <Content :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
  import ActionBar from '@/components/shared/ActionBar'
  import ActionButton from '@/components/shared/ActionButton'
  import ActionContent from '@/components/shared/ActionContent'
  import ActionPanel from '@/components/shared/ActionPanel'


  import Content from "@/components/PartManager/Views/PartImport/Middle/Content/Content"

//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'Middle',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content

  },
  props:{
    lang: Object
  },

  data () {
    return {
      toggleButtonStatus: false,
      importButtonStatus: true,
      importByPartButtonStatus: true,
      importMixButtonStatus: true,
      backButtonStatus: false,
      imported: false,
      buttonStatus: 0,
      delimiter: ",",
      types: []
    }
  },
  computed:{
    lengthMapped(){
      
      if (this.$store.getters.mappedFields.length > 0){
        this.importButtonStatus = false;
        this.importByPartButtonStatus = false;
        this.importMixButtonStatus = false;
      }else{
        this.importButtonStatus = true;
        this.importByPartButtonStatus = true;
        this.importMixButtonStatus = true;
      }
      return this.$store.getters.mappedFields.length;
    }

  },
  created() {

    this.importButtonStatus = true;
  },
  watch: {
    lengthMapped: function(newVal){
      
      if (newVal > 0){
        this.importButtonStatus = false;
        this.importByPartButtonStatus = false;
        this.importMixButtonStatus = false;
      }else{
        this.importButtonStatus = true;
        this.importByPartButtonStatus = true;
        this.importMixButtonStatus = true;
      }
     
    },
    

  },
  methods: {
    setSeparator(delimiter){
      
      this.delimiter = delimiter;
    },
    switchButtons(index){
      this.buttonStatus = index;
    },
    importing(){
      

      let _vue = this;

      let mappedFields = this.$store.getters.mappedFields;

      let propertiesTemp = []
      for (let i = 0, lei = mappedFields.length; i < lei; i++) {
        if (mappedFields[i].propertyId != "") {
          
          propertiesTemp.push(mappedFields[i].propertyId);
        }
      }
      
      
      const duplicates = propertiesTemp.filter((item, index) => index !== propertiesTemp.indexOf(item))
      

      let uniqueDuplicates = [...new Set(duplicates)];

      

      let badMatches = "";
      for (let i = 0, lei = uniqueDuplicates.length; i < lei; i++) {
        for (let j = 0, lej = mappedFields.length; j < lej; j++) {
          if (mappedFields[j].propertyId == uniqueDuplicates[i]) {
            badMatches += mappedFields[j].columnName + ", ";


          }
        }
        
        
      }
      

      

      if (duplicates.length > 0) {
        let obj = {
          text: _vue.lang.alert_error_duplicatePropertyid + " Check: " + badMatches,
          time: 15,
          type: "danger"
        }

        this.$store.dispatch("displayFooterAlert", obj)
        return;
      }

      let categoryId = "1";
      if (this.$store.getters.selectedTreeItemObject != ""){
        categoryId = this.$store.getters.selectedTreeItemObject.categoryId;
      }

      var obj = {
        categoryId: categoryId,
        documentId: this.$store.getters.importedFileId,
        allActive:  this.$store.getters.allActiveImportedParts.allActive,
        mapped: this.$store.getters.mappedFields,
        type: this.$store.getters.allActiveImportedParts.type,
        separator: this.delimiter
        }

      this.$store.dispatch("showLoader", {visible: true, text: "load"});

      this.$store.dispatch(this.$store.getters.sectionPrefix+"_MappingImportedParts", obj)
        .then(function(result){

          console.log(result.data)


         

          if (result.status == "OK"){

            _vue.imported = true;

            if (result.data.length == 0){

              let obj = {
                text: _vue.lang.alert_success_import,
                time: 5,
                type: "success"
              }

              _vue.$store.dispatch("displayFooterAlert", obj)

              _vue.$store.dispatch(_vue.$store.getters.sectionPrefix +"_resetMapField");

              const reloadObj = {
                  status: true,
                  name: "ImportHistoryComponent"
              }
              _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

            }else {

              const arr = result.data;

              _vue.$store.dispatch(_vue.$store.getters.sectionPrefix +"_setNotImportedParts", arr);

              
              let obj = {
                text: _vue.lang.alert_error_import2,
                time: 15,
                type: "warning"
              }

              _vue.$store.dispatch("displayFooterAlert", obj)

            }


            


          }else{

            let obj = {
              text: _vue.lang.alert_error_import + " Error: " + result.message,
              time: 15,
              type: "danger"
            }

            _vue.$store.dispatch("displayFooterAlert", obj)


          }



      })
      .then(function() {
        
        _vue.$store.dispatch("showLoader", {visible: false});
        
      })



    },
    getProperties() {

      
      let vue = this;
      
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getPropertiesType")
      .then(function(result){

        let obj = {
          partType: ""
        };
        for (let i = 0, lei = result.data.length; i < lei; i++){
          
          if ((result.data[i] == "text") || (result.data[i] == "link") || (result.data[i] == "library")) {
            delete obj[result.data[i]];
          } else {
            obj[result.data[i]] = "";
          }
            
        }
        

        vue.types = [obj];

        vue.importingByPart();

      })
    },
    importingByPart() {


      let _vue = this;

      
            
      for (let i = 0, lei = this.$store.getters.mappedFields.length; i < lei; i++){
        
        if (this.types[0][this.$store.getters.mappedFields[i].operationType] == ""){
          this.types[0][this.$store.getters.mappedFields[i].operationType] = this.$store.getters.mappedFields[i].columnName;
      
        }else{

          const obj = {
            text: this.lang.alert_error_DoubleTypes,
            time: 15,
            type: "danger"
          }

          
          this.$store.dispatch("displayFooterAlert", obj);

          return
        }
        
      }

      var obj = {
        category: "All components\\" + this.$store.getters.newSubCategory,
        documentId: this.$store.getters.importedFileId,
        allActive:  this.$store.getters.allActiveImportedParts,
        types: this.types,
        separator: this.delimiter
      }

      this.$store.dispatch("showLoader", {visible: true, text: "load"});

      this.$store.dispatch(this.$store.getters.sectionPrefix+"_ImportingPartByPartType", obj)
        .then(function(result){

          console.log(result.data)


          

          if (result.status == "OK"){

            _vue.imported = true;

            if (result.data.length == 0){

              let obj = {
                text: _vue.lang.alert_success_import,
                time: 10,
                type: "success"
              }

              _vue.$store.dispatch("displayFooterAlert", obj)

              _vue.$store.dispatch(_vue.$store.getters.sectionPrefix +"_resetMapField");
              _vue.$store.dispatch("reloadAfterDeleteTreeItem", true )

              const reloadObj = {
                  status: true,
                  name: "ImportHistoryComponent"
              }
              _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
            }else {

              const arr = result.data;

              _vue.$store.dispatch(_vue.$store.getters.sectionPrefix +"_setNotImportedParts", arr);

              
              let obj = {
                text: _vue.lang.alert_error_import2,
                time: 15,
                type: "warning"
              }

              _vue.$store.dispatch("displayFooterAlert", obj)

            }


            


          }else{

            let obj = {
              text: _vue.lang.alert_error_import + " Error: " + result.message,
              time: 15,
              type: "danger"
            }

            _vue.$store.dispatch("displayFooterAlert", obj)


          }



      })
      .then(function() {
        
        _vue.$store.dispatch("showLoader", {visible: false});
        
      })
    },
    importingMix() {

      

      
      let _vue = this;

      let mappedFields = this.$store.getters.mappedFields;

      
      
      let propertiesTemp = []
      for (let i = 0, lei = mappedFields.length; i < lei; i++) {
        if (mappedFields[i].propertyId != "") { 
          propertiesTemp.push(mappedFields[i].propertyId);
        }
      }
      const duplicates = propertiesTemp.filter((item, index) => index !== propertiesTemp.indexOf(item))

      

      let uniqueDuplicates = [...new Set(duplicates)];

      

      let badMatches = "";
      for (let i = 0, lei = uniqueDuplicates.length; i < lei; i++) {
        for (let j = 0, lej = mappedFields.length; j < lej; j++) {
          if (mappedFields[j].propertyId == uniqueDuplicates[i]) {
            badMatches += mappedFields[j].columnName + ", ";


          }
        }
        
        
      }

      
    
      if (duplicates.length > 0) {
        let obj = {
          text: _vue.lang.alert_error_duplicatePropertyid + " Check: " + badMatches,
          time: 15,
          type: "danger"
        }

              
        this.$store.dispatch("displayFooterAlert", obj)
        return;
      }
      var obj = {
        
        documentId: this.$store.getters.importedFileId,
        allActive: this.$store.getters.allActiveImportedParts.allActive,
        mapped: mappedFields,
        type: this.$store.getters.allActiveImportedParts.type,
        separator: this.delimiter
      }
      
      this.$store.dispatch("showLoader", { visible: true, text: "load" });

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_importPartsByCategory", obj)
        .then(function (result) {

          console.log(result.data)




          if (result.status == "OK") {

            _vue.imported = true;

            if (result.data.length == 0) {

              let obj = {
                text: _vue.lang.alert_success_import,
                time: 5,
                type: "success"
              }

              _vue.$store.dispatch("displayFooterAlert", obj)

              _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_resetMapField");

              const reloadObj = {
                status: true,
                name: "ImportHistoryComponent"
              }
              _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

              _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_getCategories", 1);

            } else {

              const arr = result.data;

              _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setNotImportedParts", arr);


              let obj = {
                text: _vue.lang.alert_error_import2,
                time: 15,
                type: "warning"
              }

              _vue.$store.dispatch("displayFooterAlert", obj)

            }





          } else {

            let obj = {
              text: _vue.lang.alert_error_import + " Error: " + result.message,
              time: 15,
              type: "danger"
            }

            _vue.$store.dispatch("displayFooterAlert", obj)


          }



        })
        .then(function () {

          _vue.$store.dispatch("showLoader", { visible: false });

        })



    },
    back(){


      if (this.imported){
        const reloadObj = {
            status: true,
            name: "DataTableFilteredOnApiComponent"
        }
        this.$store.dispatch("reloadAfterActionComplex", reloadObj);
        

      }

      let to = this.$route.query.from;

      

      
      const query = {
        from: this.$route.path,
        to: to,

      }

      this.$router.push({ path: to, query: query }); 
    },
    toggleRightPanel(){
      
      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
      
    },
    toggleLeftPanel(){
      
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
      
    }
  }
}
</script>


<style scoped>

  .middle{
    border-right: 1px solid #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartImport/Middle/Middle.vue